import React from 'react';
import RequiredAttributesMissing from './qualitySignals/RequiredAttributesMissing';
import DescriptionsMissing from './qualitySignals/DescriptionsMissing';
import GeneralAttributesMissing from './qualitySignals/GeneralAttributesMissing';
import ServicesWithActiveErratas from './qualitySignals/ServicesWithActiveErratas';
import SidebarSection from '../../../../components/sideBar/SidebarSection';
import { useZitoneoServicesStats } from '../../../../contexts/ZitoneoContentContext';
import useTranslate from '../../../../../../customHooks/useTranslate';

const QualitySignals = () => {
    const translate = useTranslate();
    const { selectedServicesInCategory } = useZitoneoServicesStats();

    return (
        <SidebarSection title='quality_signals'>
            {selectedServicesInCategory ? (
                <ul className='sidebar__quality_signals__container'>
                    <RequiredAttributesMissing />
                    <GeneralAttributesMissing />
                    <DescriptionsMissing />
                    <ServicesWithActiveErratas />
                </ul>
            ) : (
                <p>{translate('no_services_selected')}</p>
            )}
        </SidebarSection>
    );
};

export default QualitySignals;
